import { INPUT_CLASS_NAME } from "../constants";

const getInputClassName = (error) =>
  `${INPUT_CLASS_NAME} ${error ? "border-red-500 focus:border-red-500 focus:ring-red-500" : ""}`;

export function Field({
  id,
  name,
  label,
  value,
  onChange,
  type = "text",
  placeholder,
  error = false,
  errorMessage,
}) {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-semibold text-gray-900">
        {label}
      </label>
      <input
        id={id}
        name={name || id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        aria-invalid={error}
        className={getInputClassName(error)}
      />
      {error && errorMessage ? (
        <p className="mt-1 text-xs text-red-600">{errorMessage}</p>
      ) : null}
    </div>
  );
}

export function SelectField({
  id,
  name,
  label,
  value,
  onChange,
  options,
  placeholder = "Select",
  error = false,
  errorMessage,
}) {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-semibold text-gray-900">
        {label}
      </label>
      <select
        id={id}
        name={name || id}
        value={value}
        onChange={onChange}
        aria-invalid={error}
        className={getInputClassName(error)}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && errorMessage ? (
        <p className="mt-1 text-xs text-red-600">{errorMessage}</p>
      ) : null}
    </div>
  );
}

export function TextAreaField({
  id,
  name,
  label,
  value,
  onChange,
  placeholder,
  rows = 4,
  error = false,
  errorMessage,
}) {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-semibold text-gray-900">
        {label}
      </label>
      <textarea
        id={id}
        name={name || id}
        rows={rows}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        aria-invalid={error}
        className={getInputClassName(error)}
      />
      {error && errorMessage ? (
        <p className="mt-1 text-xs text-red-600">{errorMessage}</p>
      ) : null}
    </div>
  );
}
